import React, { useEffect } from 'react'
import { userModule } from '../../modules/user'
import { externalResult } from '../../api/login'
import { message } from 'antd';
import { StorageModule } from "../../modules/storage";

interface Props {
    history: any;
}

const Baidu = (props: Props) => {

    useEffect(() => {
        init()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const init = async (): Promise<any> => {
        let url = props.history.location.search.substr(1)
        console.log(props.history)
        let params: any = {}
        url.split('&').forEach((item: string) => {
            let arr = item.split('=')
            params[arr[0]] = arr[1]
        });
        const res = await externalResult(params.state);
        console.log(res?.data)
        if (!res?.data.ok) {
            message.error(res?.data.message || '绑定失败')
        }
        if (res?.data.type === 'login') {
            const user = await userModule.setUserInfoByToken(res?.data.token);
            userModule.redirectPageByUser(user, props.history, true);
        } else {
            let url: any = StorageModule.get('bind_history_url')
            props.history.push(url)
        }

        // try {
        //     const {
        //         user,
        //         isbindbaidu
        //     } = await userModule.loginByBaiduAccont(params);
        //     userModule.redirectPageByUser(user, props.history, !isbindbaidu);
        // } catch (err) {
        //     props.history.push('/login')
        // }
    }
    return (
        <div>

        </div>
    )
}

export default Baidu
